module.exports = __webpack_public_path__ + "img/arrow_left_white.2a3ef5e.svg";